import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import AltRouteOutlinedIcon from '@mui/icons-material/AltRouteOutlined'
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined'
import { SectionDefinition } from '../../../components/Sections/Sections.types'

export enum SponsorSectionIds {
  general = 'general',
  assignment = 'assignment',
  schedule = 'schedule',
}

/**
 * @description Sections shared by the Sponsor detail page and edit form, in display order.
 */
export const sponsorSections: SectionDefinition[] = [
  {
    id: SponsorSectionIds.general,
    title: 'General',
    description: 'Name, links, logo, and display priority.',
    icon: InfoOutlinedIcon,
  },
  {
    id: SponsorSectionIds.assignment,
    title: 'Applies To',
    description: 'The trail system or single trail this sponsor is shown on.',
    icon: AltRouteOutlinedIcon,
  },
  {
    id: SponsorSectionIds.schedule,
    title: 'Schedule & Visibility',
    description: 'When the sponsor is shown. Turning it off hides it regardless of the dates.',
    icon: ScheduleOutlinedIcon,
  },
]
